//
import FrontendException from './FrontendException';

class InvalidSubscriberDataException extends FrontendException {
  constructor() {
    super("Load.PreferenceCenter.ErrorUserParams");
  }
}

export default InvalidSubscriberDataException;